import actions from './actions';

const initState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.SEARCH_MEMBERSHIP_LEVELS:
    case actions.SEARCH_MEMBERSHIP_LEVEL_RULES:
    case actions.SEARCH_MEMBERSHIP_LEVEL_TRANSITION_RECORDS:
    case actions.SEARCH_MEMBERSHIP_LEVEL_MANUAL_ADJUSTMENT_RECORDS:
    case actions.SEARCH_MEMBERSHIP_LEVEL_NON_MANUAL_ADJUSTMENT_RECORDS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_MEMBERSHIP_LEVELS_ENDED:
    case actions.SEARCH_MEMBERSHIP_LEVEL_RULES_ENDED:
    case actions.SEARCH_MEMBERSHIP_LEVEL_TRANSITION_RECORDS_ENDED:
    case actions.SEARCH_MEMBERSHIP_LEVEL_MANUAL_ADJUSTMENT_RECORDS_ENDED:
    case actions.SEARCH_MEMBERSHIP_LEVEL_NON_MANUAL_ADJUSTMENT_RECORDS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.CREATE_MEMBERSHIP_LEVEL:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_MEMBERSHIP_LEVEL_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.CREATE_MEMBERSHIP_LEVEL_RULE:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_MEMBERSHIP_LEVEL_RULE_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.UPDATE_MEMBERSHIP_LEVEL:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_MEMBERSHIP_LEVEL_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.UPDATE_MEMBERSHIP_LEVEL_RULE:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_MEMBERSHIP_LEVEL_RULE_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_MEMBERSHIP_LEVELS:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_MEMBERSHIP_LEVELS_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    case actions.GET_ENABLED_MEMBERSHIP_LEVELS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.GET_ENABLED_MEMBERSHIP_LEVELS_END:
      return {
        ...state,
        levels: action.levels || [],
        isSearching: false,
      };
    default:
      return state;
  }
}
